module.exports = __webpack_public_path__ + "media/banners/friend-90dbeabd.png";